import { Endpoint } from "rest-hooks";
export const transformContractToApplication = (data) => fetch(`/changecustomer/openNewApplication`, {
    method: "post",
    body: JSON.stringify(data),
    headers: {
        "content-type": "application/json"
    }
}).then(res => {
    if (res.ok)
        return res.json();
    return res.json();
});
const TransformContractToApplicationEndpoint = new Endpoint(transformContractToApplication, {
    dataExpiryLength: 0,
    sideEffect: true
});
//# sourceMappingURL=TransformContractToApplication.js.map